import KeyboardDismissView from "@app/hoc/KeyboardDismissView";
import ScreenWrapper from "@app/hoc/ScreenWrapper";
import { PrivateStackParamList } from "@app/navigationApp/types";
import CommonHeader from "@app/sharedComponents/Header/Header";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import { Theme, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { addCommasToNumber, getDesiredValue, getTotalLimit, getUpdateAvailableCAS, isFirstSetCreditLimitVisit, roundDownToNearestHundred, trackEvent } from "@app/utils";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { LayoutAnimation, Platform, ScrollView, TouchableOpacity, UIManager } from "react-native";
import { CaretDown, CaretUp } from "@app/sharedComponents/Icons";
import { getApplicationId } from "../FetchPortfolio/utils";
import { endpoints } from "@app/api/apis";
import axios from "axios";
import { AvailableCASMap, setAuthCAS, setAvailableCAS } from "@app/store/slices/applicationSlice";
import { useEffect, useRef, useState } from "react";
import MutualFundList from "../UnlockLimitLanding/components/MutualFundsList/MutualFundsList";
import DashedLine from "@app/sharedComponents/DashedLine/DashedLine";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import Button from '@sharedComponents/Button/Button';
import { useIsFocused } from "@react-navigation/native";
import RangeSlider from "@app/sharedComponents/Slider/Slider";
import { formatIndianCurrency } from "@app/utils/utility";
import EditIcon from "@app/assets/svg/EditIcon";
import { useTheme } from "@shopify/restyle";
import EditAmountModal from "./Components/EditAmountModal";
import { useIsEnhanceLimit } from "@app/hooks/useIsEnhanceLimit";
import ROUTE from "@app/navigationApp/routes";
import handleApiErr from "@app/helper/handleApiErr";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import useIsMobileBrowser from "@app/hooks/useIsMobileBrowser";
import { updatePartnerParams } from "@app/store/slices/platformSlice";
import { getExperimentCohort, getRecommendedOffer } from "@app/utils/creditFlowAnalytics";
import { filterByRepository } from "../UnlockLimitLanding/utils";
type SetCreditLimitProps = NativeStackScreenProps<PrivateStackParamList, 'SET_CREDIT_LIMIT'> & {

}

const SetCreditLimit = ({
    navigation,
    route
}: SetCreditLimitProps) => {

    const { minimumEligibleLimit, authCAS, availableCAS } = useAppSelector(state => state.application);
    const { userDetails } = useAppSelector((state) => state.auth);
    const [sliderValue, setSliderValue] = useState(authCAS?.availableCreditAmount || 0);
    const [portValue, setPortValue] = useState(0);
    const dispatch = useAppDispatch();
    const isFocused = useIsFocused();
    const [btnLoading, setBtnLoading] = useState(false);
    const { colors } = useTheme<Theme>()
    const [showEditAmountModal, setShowEditAmountModal] = useState(false);
    const { isFromEnhanceLimit } = useIsEnhanceLimit();
    const isMobileBrowser = useIsMobileBrowser();
    const [availableCASData, setAvailableCASData] = useState<AvailableCASMap>({});
    const [showFundDetails, setShowFundDetails] = useState(false);
    const firebaseParams = useAppSelector((state) => state.firebaseParams);
    const platformCode = userDetails?.linkedPlatformAccounts?.[0]?.platformCode;
    const toggleMutualFundListForPlateform = firebaseParams?.toggle_mutual_fund_list_for_plteform;
    
    const toggleMutualFundList = Boolean(
        platformCode && toggleMutualFundListForPlateform?.includes(platformCode.toUpperCase())
    );

    if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
        UIManager.setLayoutAnimationEnabledExperimental(true);
    }

    const toggleFundDetails = () => {
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
        setShowFundDetails((prev) => !prev);
    };

    let rta = undefined

    // Common analytics props for SETLIMIT events. Cohort C has a single
    // interest rate (no dual {ROI1,ROI2} tiers), so `interest_rate` is scalar.
    const buildSetLimitProps = () => ({
        max_eligible_credit_limit: authCAS?.availableCreditAmount ?? 0,
        selected_credit_limit: sliderValue,
        recommended_offer: getRecommendedOffer(
            (authCAS as any)?.selectedOfferCode,
            (authCAS as any)?.offers,
        ),
        interest_rate: (authCAS as any)?.interestRate ?? 0,
        experiment_cohort: getExperimentCohort(),
        source_page: route.name,
    });

    const pageViewedRef = useRef(false);
    useEffect(() => {
        if (!authCAS || pageViewedRef.current) return;
        pageViewedRef.current = true;
        trackEvent('SET_MF_LIMIT_AMOUNT_PAGE_VIEWED', buildSetLimitProps());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authCAS]);

    useEffect(() => {
        if (availableCAS) {
            setAvailableCASData(
                (rta ? availableCAS && filterByRepository(availableCAS, rta === 'MFCENTRAL' ? 'ALL' : rta) : availableCAS) ?? {}
            );
        } else {
            setAvailableCASData(
                (rta ? authCAS?.availableCAS && filterByRepository(authCAS?.availableCAS, rta === 'MFCENTRAL' ? 'ALL' : rta) : authCAS?.availableCAS) ?? {}
            );
        }
    }, [authCAS, availableCAS, rta]);

    const sliderValueSynced = addCommasToNumber(
        roundDownToNearestHundred(
            getTotalLimit(
                Object.values(availableCASData ?? {}),
                authCAS?.isinNAVMap,
                authCAS?.isinLTVMap
            )
        )
    )
            


    const initialiseAvailableCAS = (availableCAS: any[]) => {
        const updatedAvailableCAS: AvailableCASMap = {}
        const _availableCAS = availableCAS;
        if (_availableCAS) {
            _availableCAS.forEach((item) => {
                updatedAvailableCAS[item.isinNo + '-' + item.folioNo] = {
                    ...item,
                    pledgedUnits: item.totalAvailableUnits,
                    isPledged: true
                };
            });
        }
        dispatch(setAvailableCAS(updatedAvailableCAS));
        return updatedAvailableCAS;
    }

    const outOfValue = availableCAS && authCAS && addCommasToNumber(
        roundDownToNearestHundred(
            getTotalLimit(
                Object.values(availableCAS),
                authCAS.isinNAVMap,
                authCAS.isinLTVMap
            )
        )
    )

    const ctaDisabled = parseInt(outOfValue?.replace(/,/g, '') ?? '0') < (minimumEligibleLimit?.amount ?? 10000)

    const selectedFundsCount = availableCAS
        ? Object.values(availableCAS).filter((item) => item.pledgedUnits > 0).length
        : 0;


    const savePledgeLimit = async () => {
        let pledgeDataToSave = availableCAS && Object.values(availableCAS).filter((item) => item.pledgedUnits > 0);
        pledgeDataToSave = pledgeDataToSave && pledgeDataToSave.map((item) => ({
            ...item,
            is_pledged: item.pledgedUnits > 0 ? true : false
        }));
        setBtnLoading(true);
        const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
        const url = endpoints.pledgeSave;
        await axios.post(url, {
            applicationId: applicationId,
            portfolioItemList: pledgeDataToSave
        }).then((response) => {
            if(isFromEnhanceLimit) {
                navigation.navigate(ROUTE.LOAN_OFFER_ENHANCE_LIMIT , {source: 'SET_CREDIT_LIMIT'});
            } else {
                navigation.navigate(ROUTE.PLEDGE_CONFIRMATION);
            }
            setBtnLoading(false);
        }).catch((error) => {
            if (error?.data?.statusCode && handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: error?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
            setBtnLoading(false);
        });
    }

    const isSelectedForPledge = isFirstSetCreditLimitVisit(Object.values(availableCAS ?? {})) && Platform.OS !== 'web';

    //to handle when the user come back from the portfolio screen
    useEffect(() => {
        if (
            (route.params?.fromEditSelection || Platform.OS !== 'web') && 
            availableCAS && 
            authCAS?.isinNAVMap
        ) {
            const portValue = getDesiredValue(
                Object.values(availableCAS),
                authCAS?.isinNAVMap
            );
            setPortValue(portValue);
            const sliderValue = addCommasToNumber(
                roundDownToNearestHundred(
                    getTotalLimit(
                        Object.values(availableCAS),
                        authCAS.isinNAVMap,
                        authCAS.isinLTVMap
                    )
                )
            )
            if (Platform.OS === 'web') {
                setSliderValue(parseInt(sliderValue?.replace(/[^0-9]/g, "")));
            } else {
                setSliderValue(parseInt(sliderValueSynced?.replace(/[^0-9]/g, "")));
            }
        }
    }, [isFocused , sliderValueSynced]);

    useEffect(() => {
        if (availableCAS && authCAS?.isinNAVMap) {
            const portValue = getDesiredValue(
                Object.values(availableCAS),
                authCAS?.isinNAVMap
            );
            setPortValue(portValue);
        }
    }, [availableCAS]);

    useEffect(() => {
        authCAS && initialiseAvailableCAS(authCAS?.availableCAS);
    }, [authCAS]);

    useEffect(() => {
        // user reaches here only after min limit is reached hence marking showCall as true in case of refresh or anything
        dispatch(updatePartnerParams({showCall:true}))
    }, [])

    const renderDetails = () => {
        return (
            <ThemedView backgroundColor="bg-surface-page" style={{ flex: 1, borderTopLeftRadius: 16, borderTopRightRadius: 16, position: 'relative', bottom: 16 }}>
                <ThemedView style={{ paddingHorizontal: 16 }}>
                    {toggleMutualFundList ? (
                        <ThemedView pt="2xl">
                            <ThemedPressable
                                onPress={toggleFundDetails}
                                flexDirection="row"
                                justifyContent="space-between"
                                alignItems="center"
                                style={{ paddingBottom: showFundDetails ? 0 : 24 }}
                            >
                                <ThemedText variant="h5s" color="text-primary">Your mutual funds</ThemedText>
                                <ThemedView flexDirection="row" alignItems="center">
                                    <ThemedText variant="b3s" color="text-action-primary">{showFundDetails ? 'Hide' : 'Show'}</ThemedText>
                                    <ThemedView style={{ marginLeft: 6 }}>
                                        {showFundDetails ? (
                                            <CaretUp size={14} color={colors['icon-action-primary']} weight="bold" />
                                        ) : (
                                            <CaretDown size={14} color={colors['icon-action-primary']} weight="bold" />
                                        )}
                                    </ThemedView>
                                </ThemedView>
                            </ThemedPressable>
                            {showFundDetails && (
                                <>
                                    <ThemedView my="lg">
                                        <DashedLine />
                                    </ThemedView>
                                    <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <ThemedText variant="b2s" color="text-primary">{selectedFundsCount} {selectedFundsCount === 1 ? 'fund' : 'funds'}</ThemedText>
                                        <TouchableOpacity onPress={() => {
                                            !btnLoading &&
                                            navigation.navigate('PORTFOLIO');
                                            trackEvent('SET_CREDIT_LIMIT_EDITMF_EDITFUNDAMOUNT_CLICKED',buildSetLimitProps())
                                        }}>
                                            <ThemedText variant="b3s" color="text-action-primary">Edit funds</ThemedText>
                                        </TouchableOpacity>
                                    </ThemedView>
                                    <ThemedText mt="md" variant="b3r" color="text-secondary">₹{addCommasToNumber(portValue || 0)} out of ₹{addCommasToNumber(authCAS?.totalPortfolioAmount || 0)} are selected for pledging.</ThemedText>
                                    <MutualFundList />
                                </>
                            )}
                        </ThemedView>
                    ) : (
                        <>
                            <ThemedView style={{ marginBottom: 12 }} />
                            <ThemedView style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                            </ThemedView>
                            <ThemedView style={{ marginBottom: 18 }} />
                            <ThemedView style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <ThemedText variant="h5s" color="text-primary" textAlign='center'>Selected mutual funds
                                </ThemedText>
                                <TouchableOpacity onPress={() => {
                                    !btnLoading &&
                                    navigation.navigate('PORTFOLIO');
                                    trackEvent('SET_CREDIT_LIMIT_EDITMF_EDITFUNDAMOUNT_CLICKED',{
                                        amount: sliderValue
                                    })
                                }}>
                                    <ThemedText variant="b3s" color="text-action-primary" textAlign='center'>Edit selection</ThemedText>
                                </TouchableOpacity>
                            </ThemedView>
                            <ThemedView style={{ marginBottom: 12 }} />
                            <ThemedText variant="b3r" color="text-secondary" >₹{addCommasToNumber(portValue || 0)} out of ₹{addCommasToNumber(authCAS?.totalPortfolioAmount || 0)} are selected for pledging.</ThemedText>
                            <MutualFundList />
                        </>
                    )}
                </ThemedView>
            </ThemedView>
        )
    }

    const computeAuthCasOnValueChange = (value: number) => {
        let updateAvailableCASMap: AvailableCASMap = { ...availableCAS };
        // console.log("DSR updatedAvailableCAS: ", updatedAvailableCAS); 
        if (value > 0) {
            if (authCAS && availableCAS) {
                let _authCas = { ...authCAS }; // Create a proper copy
                _authCas.availableCAS = _authCas.availableCAS.map(item => ({
                    ...item,
                    pledgedUnits: item.totalAvailableUnits
                }));
                const updatedAvailableCAS = getUpdateAvailableCAS(
                    value,
                    _authCas.availableCAS,
                    _authCas.isinNAVMap,
                    _authCas.isinLTVMap
                );
                updatedAvailableCAS.forEach((item) => {
                    const key = `${item.isinNo}-${item.folioNo}`;
                    updateAvailableCASMap[key] = item;
                });
            }
        } else {
            if (authCAS && availableCAS) {
                authCAS.availableCAS.map((item) => {
                    const key = `${item.isinNo}-${item.folioNo}`;
                    item.pledgedUnits = item.totalAvailableUnits;
                    updateAvailableCASMap[key] = item;
                });
            }
        }
        dispatch(setAvailableCAS(updateAvailableCASMap))
    }

    const sliderComplete = (value: number) => {
        trackEvent('SETLIMIT_SLIDER_CLICKED', {
            ...buildSetLimitProps(),
            selected_credit_limit: value,
        });
        computeAuthCasOnValueChange(value);
    }

    return (<>
        <ScreenWrapper screenName={route.name}>
                <ThemedView flex={1} backgroundColor="bg-surface-primary">
                    <CommonHeader
                        label='Set credit limit'
                        navigation={navigation}
                        pageName={route.name}
                        backEventName="SETLIMIT_BACK_CLICKED"
                        backEventProperties={buildSetLimitProps()}
                    />
                    <ScrollView
                        style={{ flex: 1 }}
                        showsVerticalScrollIndicator={false}
                        keyboardShouldPersistTaps='handled'
                    >
                        <ThemedView style={{ flex: 1 }}>
                            <ThemedView style={{ paddingHorizontal: 16 }} backgroundColor="bg-surface-page">
                                <ThemedView style={{ marginBottom: 32 }} />
                                <ThemedText variant="h5s" color="text-primary" textAlign='center'>
                                    Select the amount
                                </ThemedText>
                                <ThemedView style={{ marginBottom: 18 }} />
                                {
                                    authCAS && minimumEligibleLimit &&
                                    <ThemedView>
                                        <ThemedView mb="5xl" flexDirection='row' justifyContent='center' alignItems='center'>
                                            <ThemedText variant="h1b" color="text-primary" textAlign='center'>
                                            <ThemedText fontFamily='Inter' variant="h1b" color="text-primary" textAlign='center'>₹</ThemedText>
                                                {formatIndianCurrency(sliderValue.toFixed(0))} </ThemedText>
                                            <TouchableOpacity
                                             hitSlop={{left : 10 , right :10 , bottom : 10 , top :10}}
                                            onPress={() => {
                                                // setOpenUpdateNumber(true)
                                                setShowEditAmountModal(true)
                                                trackEvent('EDIT_AMOUNT_BUTTON_CLICKED', buildSetLimitProps())
                                            }}>
                                                <EditIcon size={20} color={colors['icon-action-primary']} />
                                            </TouchableOpacity>
                                        </ThemedView>
                                        <RangeSlider
                                            min={minimumEligibleLimit?.amount}
                                            max={authCAS?.availableCreditAmount}
                                            value={sliderValue}
                                            onChange={(value) => {
                                                if(btnLoading) return;
                                                setSliderValue(value)
                                            }}
                                            onComplete={(value) => {
                                                if(btnLoading) return;
                                                sliderComplete(value)
                                            }}
                                        />
                                    </ThemedView>
                                }
                                <ThemedView style={{ marginBottom: 12 }} />
                                <ThemedView style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <ThemedText variant="b4r" color="text-secondary" textAlign='center'>
                                        Min ₹{addCommasToNumber(minimumEligibleLimit?.amount || 0)}
                                    </ThemedText>
                                    <ThemedText variant="b4r" color="text-secondary" textAlign='center'>
                                        Max ₹{addCommasToNumber(authCAS?.availableCreditAmount || 0)}
                                    </ThemedText>
                                </ThemedView>
                                <ThemedView style={{ marginBottom: 24 }} />
                                <ThemedView style={{ marginBottom: 24 }} />
                            </ThemedView>
                            {renderDetails()}
                        </ThemedView>
                    </ScrollView>
                    {(!showEditAmountModal || Platform.OS !== 'web') && (
                        <ThemedView
                            backgroundColor='bg-fill-primary'
                            borderTopWidth={1}
                            borderTopColor='border-primary'
                        >
                            <ThemedView m="lg">
                                <Button
                                    label={'Confirm limit and proceed'}
                                    handlePress={() => {
                                        if (btnLoading) return;
                                        trackEvent('SETLIMIT_CONFIRM&PROCEED_CLICKED', buildSetLimitProps());
                                        savePledgeLimit();
                                    }}
                                    type={'SOLID'}
                                    size='MD'
                                    bg='bg-primary'
                                    textColor='text-primary'
                                    disabled={ctaDisabled || btnLoading}
                                    buttonLoader={btnLoading}
                                />
                            </ThemedView>
                        </ThemedView>
                    )}
                </ThemedView>
            <BottomSheetContainer
                isVisible={showEditAmountModal}
                closeOnBackdropPress={false}
                close={() => setShowEditAmountModal(false)}
                onClose={() => setShowEditAmountModal(false)}
                dragComponent={<ThemedView style={{ height: 12 }} />}
                containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 ,
                    maxHeight: Platform.OS === 'web' ? '80%' : undefined,
                    minHeight: !isMobileBrowser ? undefined : 250, 
                }}
                showCloseIcon={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}

            >
                <EditAmountModal initialAmount={sliderValue}
                    onChange={(amount) => {
                            trackEvent('SETLIMIT_EDITAMOUNT_AMOUNTCONFIRM_CLICKED', {
                                ...buildSetLimitProps(),
                                selected_credit_limit: amount,
                            })
                            setShowEditAmountModal(false)
                            setTimeout(() => {
                                setSliderValue(amount)
                                computeAuthCasOnValueChange(amount)
                            }, 0)
                    }}
                    minAmount={minimumEligibleLimit?.amount || 0}
                    maxAmount={authCAS?.availableCreditAmount || 0}
                />
            </BottomSheetContainer>
        </ScreenWrapper>
    </>)
}

export default SetCreditLimit;